.section {
  padding-bottom: 0;
}

/* Match the Number-modeling + Currency + Expanded-form headings so
 * the four sections all read at the same scale. */
.section h2 {
  font-family: var(--token-font-display);
  margin: 0 0 var(--token-space-md);
  font-size: 33px;
  color: var(--token-text-primary);
}

.row {
  display: flex;
  gap: var(--token-space-md);
}

.button {
  min-width: var(--token-touch-min);
  min-height: var(--token-touch-min);
  padding: var(--token-space-md) var(--token-space-2xl);
  border-radius: var(--token-radius-pill);
  border: 2px solid rgba(8, 18, 12, 0.16);
  background: var(--token-card-bg);
  font-family: var(--token-font-display);
  font-size: 24px;
  cursor: pointer;
}

.button[aria-checked='true'] {
  background: var(--token-accent);
  color: var(--token-card-bg);
  border-color: var(--token-accent);
}
